<template>
    <button class="overlay-close-btn"
            :class="bemFacets"
            @click="onClose">
        <slot>
            <base-icon class="overlay-close-btn--icon" symbol="close" size="small"/>
        </slot>
    </button>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex';
    import bemFacet from '@dreipol/vue-ui/src/mixins/bem';

    export default {
        mixins: [bemFacet('overlay-close-btn')],
        computed: {
            ...mapGetters('overlay', ['currentOverlay']),
        },
        methods: {
            ...mapActions('overlay', ['closeOverlay']),

            onClose() {
                this.closeOverlay({ id: this.currentOverlay.id });
                this.$emit('close');
            },
        },
    };
</script>
